export const manifest = {
  screens: {
    scr_lkufui: { name: "Home", route: "/" },
  },
}
